import type { ClientToolExecution } from '@/apis/assistant'

import type { AssistantMessage } from './assistant-models'

export function applyClientToolResult(
  message: AssistantMessage,
  execution: ClientToolExecution
): AssistantMessage {
  if (!execution.uiData) return message
  if (execution.uiData.records.length === 0) {
    return {
      ...message,
      kind: 'text',
      text: '当前查询条件没有下载生产的记录',
      productionHistory: undefined,
      productionRecords: undefined,
      productionSummary: undefined,
    }
  }
  return {
    ...message,
    productionRecords: execution.uiData.records,
    productionSummary: {
      total: execution.uiData.total,
      returned: execution.uiData.returned,
      page: execution.uiData.page,
      limit: execution.uiData.limit,
      note: execution.uiData.note,
    },
  }
}
